import * as React from 'react'
import { Button } from 'primereact/button'
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox'
import { ObjectUtils } from 'primereact/utils'
import { showAlert } from '../utils/util'
import { COMAGM0101 } from 'app/pages/com/agm/COMAGM0101'
import { usePopup } from '../hooks/popup'
import { useCommonCode, WtcnsUrlAdr } from '../hooks/util/commonCode.hook'

export type TermsMarketing = {
    /**
     * 마케팅동의여부
     */
    mrknCosnYn?: 'Y' | 'N'
    /**
     * 마케팅정보수신동의여부
     */
    mrknInfoRcctYn?: 'Y' | 'N'
    /**
     * SMS마케팅동의여부
     */
    smsMrknCosnYn?: 'Y' | 'N'
    /**
     * 전화마케팅동의여부
     */
    telMrknCosnYn?: 'Y' | 'N'
    /**
     * 이메일마케팅동의여부
     */
    emlMrknCosnYn?: 'Y' | 'N'
    /**
     * 우편물마케팅동의여부
     */
    psmlMrknCosnYn?: 'Y' | 'N'
}
/**
 * 명세서에서 동의할 때 받는 값이 차이가 있음, 개인정보(신용)동의 항목이 없음
 * 
1	evncd	String	N	이벤트코드		
1	smsMrknCosnYn	String	N	SMS마케팅동의여부		
1	emlMrknCosnYn	String	N	이메일마케팅동의여부		
1	psmlMrknCosnYn	String	N	우편물마케팅동의여부		
1	telMrknCosnYn	String	N	전화마케팅동의여부		
1	mrknInfoRcctYn	String	N	마케팅정보수신동의여부
 */
export type TermListMarketingProps = {
    terms?: TermsMarketing
    /**
     * 약관 동의 상태가 변경되면 trigger. 뭐가 필요할지 몰라 다 보냄
     * @param terms 약관 동의 상태 props terms에 보낸대로 'Y', 'N'으로 채워보냄
     * @param isAllChecked 전체 약관(수신 방법 제외) 동의가 완료되면 true, 그 외 false
     */
    onChange?(terms: TermsMarketing, isAllChecked: boolean): void
    /**
     부모 class
     */
    className?: string
}
//마케팅은 약관 고정이다.
type termItem = {
    id: string
    name: string
    termId?: string
    items?: termItem[]
}
const termList: termItem[] = [
    {
        id: 'mrknCosnYn',
        name: '개인(신용) 정보 수집 이용 동의',
        termId: 'mrknCosnYn',
        items: [],
    },
    {
        id: 'mrknInfoRcctYn',
        name: '광고성 정보 수신 동의',
        items: [
            { id: 'smsMrknCosnYn', name: '문자메시지' },
            {
                id: 'telMrknCosnYn',
                name: '전화',
            },
            {
                id: 'emlMrknCosnYn',
                name: '이메일',
            },
            { id: 'psmlMrknCosnYn', name: '우편물' },
        ],
    },
]
/**
 * 서버에서 값을 안넘기는 것을 대비해 만들어 뒀다.
 */
const defaultTerms = {
    mrknCosnYn: 'N',
    mrknInfoRcctYn: 'N',
    smsMrknCosnYn: 'N',
    telMrknCosnYn: 'N',
    emlMrknCosnYn: 'N',
    psmlMrknCosnYn: 'N',
}
export const TermListMarketing: React.FC<TermListMarketingProps> = (props) => {
    const { terms, onChange, className = 'mt-16' } = props
    //check여부를 저장하는 terms
    const [checkAgree, setCheckAgree] = React.useState<TermsMarketing>(
        ObjectUtils.getMergedProps(terms, defaultTerms)
    )

    const { data: commonCode } = useCommonCode<{ data: WtcnsUrlAdr[] }>({
        dsrnTgtBacd: '110',
        cdgpId: 'WTCNS_URL_ADR',
        ccddId: '',
    })

    const termInfo = commonCode?.data.find((x) => x.ccddId === 'TERM-042')

    const termPopup = usePopup()

    React.useEffect(() => {
        setCheckAgree(ObjectUtils.getMergedProps(terms, defaultTerms))
    }, [terms])
    /**
     * 체크 박스 이벤트, 루프를 줄이기 위해 종류별로 생성한다.
     */
    /**
     * 하위 약관이 없는 단순 약관의 체크 박스
     * @param e
     */
    const handleCheckChange = (e: CheckboxChangeEvent) => {
        const name = e.target.name
        const checked = e.checked
        //단순 복재본 생성
        const newTerms: TermsMarketing = ObjectUtils.getMergedProps(
            checkAgree,
            {}
        )
        newTerms[name] = checked ? 'Y' : 'N'

        if (!checked) {
            newTerms.mrknInfoRcctYn = 'N'
            newTerms.emlMrknCosnYn = 'N'
            newTerms.psmlMrknCosnYn = 'N'
            newTerms.smsMrknCosnYn = 'N'
            newTerms.telMrknCosnYn = 'N'
        }
        setCheckAgree(newTerms)
        onChange?.(newTerms, false)
    }
    /**
     * 하위 약관이 있는 부모 약관의 체크 박스
     * @param e
     */
    const handleCheckParentChange = (
        e: CheckboxChangeEvent,
        children: termItem[]
    ) => {
        const name = e.target.name
        const checked = e.checked ? 'Y' : 'N'

        if (checked === 'Y' && checkAgree.mrknCosnYn !== 'Y') {
            showAlert({
                msg: '개인(신용)정보 수집이용 동의 후에 광고성 정보 수신 동의할 수 있습니다.',
            })
            return
        }

        //단순 복재본 생성
        const newTerms: TermsMarketing = ObjectUtils.getMergedProps(
            checkAgree,
            {}
        )
        newTerms[name] = checked
        //부모 체크 상태에 따라 자식들을 업데이트 시킨다.
        children.forEach((item) => {
            newTerms[item.id] = checked
        })
        setCheckAgree(newTerms)
        onChange?.(newTerms, false)
    }
    /**
     * 부모 하위 약관이 있는 자식 약관의 체크 박스
     * @param e
     */
    const handleCheckChildChange = (
        e: CheckboxChangeEvent,
        parentName: string,
        children: termItem[]
    ) => {
        const name = e.target.name
        const checked = e.checked

        if (checked && checkAgree.mrknCosnYn !== 'Y') {
            showAlert({
                msg: '개인(신용)정보 수집이용 동의 후에 광고성 정보 수신 동의할 수 있습니다.',
            })
            return
        }

        //단순 복재본 생성
        const newTerms = ObjectUtils.getMergedProps(checkAgree, {})
        //우선 자신을 업데이트 시키고
        newTerms[name] = checked ? 'Y' : 'N'
        //자신과 형제들의 상태를 본다. 한 개라도 체크 되어 있으면 부모도 체크 상태다.
        newTerms[parentName] = 'N'
        const len = children.length - 1
        for (let i = 0; i <= len; i++) {
            const childName = children[i].id
            if (newTerms[childName] === 'Y') {
                newTerms[parentName] = 'Y'
                break
            }
        }
        setCheckAgree(newTerms)
        onChange?.(newTerms, false)
    }
    /**
     * 전체 선택 체크 박스
     * @param e
     */
    const handleCheckAllChange = (e: CheckboxChangeEvent) => {
        const checked = e.checked ? 'Y' : 'N'
        //단순 복재본 생성
        const newTerms = ObjectUtils.getMergedProps(checkAgree, {})
        for (const name in newTerms) {
            newTerms[name] = checked
        }
        setCheckAgree(newTerms)
        onChange?.(newTerms, e.checked)
    }

    // 전체 동의 체크 - 자식 약관 동의 여부가 전체 동의 조건인가??
    const isAllChecked = (newTerms = checkAgree) => {
        let checked = true
        termList.forEach((item) => {
            checked = checked && newTerms?.[item.id] === 'Y'
            // item.items.forEach((subItem) => {
            //     checked = checked && newTerms?.[subItem.id] === 'Y'
            // })
        })
        return checked
    }

    //약관 동의
    const handleOnAgree = (agree: boolean) => {
        termPopup.close()

        if (agree) {
            setCheckAgree((prev) => {
                prev.mrknCosnYn = 'Y'
                return prev
            })
        }
    }

    return (
        <div
            className={`clause checkboxs-agree ${className}
            }`.trim()}
        >
            <COMAGM0101
                data={
                    termInfo
                        ? [
                              {
                                  pdfNm: termInfo.cdNm,
                                  pdfType: termInfo.cdAtrbEtc2Con,
                                  pdfUrl: termInfo.cdAtrbEtc1Con,
                              },
                          ]
                        : []
                }
                visible={termPopup.state}
                onAgree={handleOnAgree}
            />
            <div className="group">
                <div className="checkbox-basic -big">
                    <Checkbox
                        inputId="checkbox_marketing_all"
                        onChange={handleCheckAllChange}
                        checked={isAllChecked()}
                    />
                    <label htmlFor="checkbox_marketing_all">
                        개인(신용)정보 수집 · 이용 동의서 (상품서비스 안내)
                        <span className="req req-type">선택</span>
                    </label>
                </div>
            </div>
            <div className="group-toggle" aria-hidden="false">
                <div className="list">
                    {termList.map((item) => (
                        <React.Fragment key={item.id}>
                            <div className="group">
                                <div className="checkbox-basic">
                                    <Checkbox
                                        inputId={item.id}
                                        value={item.id}
                                        name={item.id}
                                        onChange={(e) => {
                                            if (item.items.length > 0) {
                                                handleCheckParentChange(
                                                    e,
                                                    item.items
                                                )
                                                return
                                            }
                                            handleCheckChange(e)
                                        }}
                                        checked={checkAgree[item.id] === 'Y'}
                                    />

                                    <label htmlFor={item.id}>{item.name}</label>
                                </div>
                                {item.termId && termInfo && (
                                    <Button
                                        className="btn-view"
                                        label="보기"
                                        title={`${termInfo.cdNm} 약관보기`}
                                        onClick={termPopup.open}
                                    />
                                )}
                            </div>
                            {item.items.length > 0 && (
                                <div className="clause-type">
                                    <div className="group-toggle">
                                        {item.items.map((subItem) => (
                                            <div
                                                className="group"
                                                key={subItem.id}
                                            >
                                                <div className="checkbox-basic">
                                                    <Checkbox
                                                        inputId={subItem.id}
                                                        value={subItem.id}
                                                        name={subItem.id}
                                                        onChange={(e) => {
                                                            handleCheckChildChange(
                                                                e,
                                                                item.id,
                                                                item.items
                                                            )
                                                        }}
                                                        checked={
                                                            checkAgree[
                                                                subItem.id
                                                            ] === 'Y'
                                                        }
                                                    />
                                                    <label htmlFor={subItem.id}>
                                                        {subItem.name}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    )
}
